import React, { useEffect, useRef, useState } from 'react';
import styles from './SubtitlesLanguageMenu.module.scss';
import { TurnOnSubtitlesIcon } from '../Player/VideoControls';
import Menu from '../Menu/Menu';
import MenuItem from '../Menu/MenuItem';
import Icon from '../Icon/Icon';
import useOutsideClick from '../../hooks/useOutsideClick';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const initLanguagesMenu = {
  show: false,
  x: 0,
  y: 0,
};

const SubtitlesLanguageMenu = ({
  playerNode,
  languagesList,
  isMobileView,
  currentLanguage,
  handleLanguageChoose,
  hideControls,
  className,
}) => {
  const [languagesMenu, setLanguagesMenu] = useState(initLanguagesMenu);
  const [menuStyles, setMenuStyles] = useState({ top: 0, left: 0, opacity: 0 });
  const menuRef = useRef(null);

  const { t } = useTranslation();

  useOutsideClick(menuRef, () => {
    if (languagesMenu.show) {
      setLanguagesMenu(initLanguagesMenu);
    }
  });

  const handleLanguage = value => {
    setLanguagesMenu(initLanguagesMenu);
    handleLanguageChoose(value);
  };

  const handleOpenMenu = e => {
    setLanguagesMenu({ show: true, x: e.clientX, y: e.clientY });
  };

  useEffect(() => {
    if (hideControls) {
      setLanguagesMenu(initLanguagesMenu);
    }
  }, [hideControls]);

  useEffect(() => {
    if (menuRef.current) {
      let top = languagesMenu.y;
      let left = languagesMenu.x;
      if (isMobileView) {
        left = playerNode?.offsetWidth + menuRef.current.offsetWidth / 2;
        if (menuRef.current.offsetHeight > playerNode?.offsetHeight) {
          top += playerNode?.offsetHeight;
        }
      } else {
        left += 100;
      }
      setMenuStyles({ top, left, opacity: 1 });
    }
  }, [languagesMenu]);

  return (
    <>
      <div role="button" className={className} onClick={handleOpenMenu} title="control video subtitles" tabIndex={0}>
        {currentLanguage ? (
          <span className={styles.currentLanguageWrapper}>{currentLanguage.slice(0, 2).toUpperCase()}</span>
        ) : (
          <TurnOnSubtitlesIcon />
        )}
      </div>
      {languagesMenu.show && (
        <Menu ref={menuRef} className={styles.languagesMenu} customStyles={menuStyles}>
          <span className={styles.menuHeader}>{t('my_video.controls.subtitles_langugaes')}</span>
          {currentLanguage && (
            <MenuItem key={'turn_off'} onClick={() => handleLanguage('')} className={styles.item}>
              <span className={cx({ [styles.notChecked]: true })}>Turn off</span>
            </MenuItem>
          )}
          {languagesList.map(language =>
            language?.id ? (
              <MenuItem onClick={() => handleLanguage(language.id)} key={language?.id} className={styles.item}>
                {currentLanguage === language.id && <Icon src="subtitlesLangaugeCheck" className={styles.checkIcon} />}
                <span className={cx({ [styles.notChecked]: currentLanguage !== language.id })}>{language.name}</span>
              </MenuItem>
            ) : null
          )}
        </Menu>
      )}
    </>
  );
};

export default SubtitlesLanguageMenu;
